import { PdfJsDistService } from '@showpad/asset-viewer-v2';
import { STATIC_PATH } from '../../helpers/constants';

export class PdfJsService {
    constructor(flags) {
        this.pdfJsResourcesPromise = null;
        this.flags = flags;
    }

    loadPdfJsResources() {
        if (this.pdfJsResourcesPromise) {
            return this.pdfJsResourcesPromise;
        }
        const PDF_JS_PATH = require('!!file-loader?name=[name]-[hash].[ext]!@showpad/pdfjs-dist/build/pdf.min.js').default;
        const PDF_JS_WORKER_PATH = require('!!file-loader?name=[name]-[hash].[ext]!@showpad/pdfjs-dist/build/pdf.worker.min.js').default;
        const PDF_JS_TEXT_LAYER_BUILDER_CSS_PATH =
            require('!!file-loader?name=[name]-[hash].[ext]!@showpad/pdfjs-dist/web/text_layer_builder.css').default;
        const PDF_JS_ANNOTATION_LAYER_BUILDER_CSS_PATH =
            require('!!file-loader?name=[name]-[hash].[ext]!@showpad/pdfjs-dist/web/annotation_layer_builder.css').default;
        const PDF_JS_CMAPS_PATH = `${STATIC_PATH}cmaps/`;

        this.pdfJsResourcesPromise = Promise.resolve().then(() => {
            const config = {
                src: PDF_JS_PATH,
                workerSrc: PDF_JS_WORKER_PATH,
                textLayerBuilderCssUrl: PDF_JS_TEXT_LAYER_BUILDER_CSS_PATH,
                annotationLayerBuilderCssUrl: PDF_JS_ANNOTATION_LAYER_BUILDER_CSS_PATH,
                cMapUrl: PDF_JS_CMAPS_PATH,
            };
            return new PdfJsDistService(config).loadResources();
        });

        return this.pdfJsResourcesPromise;
    }

    getWorker() {
        return new window.pdfjsLib.PDFWorker();
    }
}
